<template>
  <Modal
    v-if="showModal"
    title="Delete checklist"
    body="Are you sure you want to delete this checklist? This will permanently delete the checklist and all its tasks, including any tasks already assigned to people on your team."
    action="Delete"
    actionColor="red"
    @closeModal="handleCloseModal"
    @handleAction="handleAction"
  />
</template>

<script>
import Modal from '../../../shared/Modal.vue';

export default {
  components: {
    Modal,
  },
  props: {
    showModal: { type: Boolean, required: true },
  },
  methods: {
    handleCloseModal() {
      this.$emit('closeModal');
    },
    handleAction() {
      this.$emit('action');
    },
  },
};
</script>
